import { render, staticRenderFns } from "./MyRewards.vue?vue&type=template&id=be798c5a&scoped=true"
import script from "./MyRewards.vue?vue&type=script&lang=js"
export * from "./MyRewards.vue?vue&type=script&lang=js"
import style0 from "./MyRewards.vue?vue&type=style&index=0&id=be798c5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be798c5a",
  null
  
)

export default component.exports